import React, { Component } from 'react';
import { withRouter } from 'react-router';
import styles from './style.module.css';

class ProgressBar extends Component {
    render() {
        const {
            props: {
                location,
                routes = []
            }
        } = this;

        const currentRoute = routes.find(({ path }) => location.pathname.endsWith(path)) || routes[0];
        const routeProgressBar = currentRoute.progressBar;
        let progressPercent = '0%';
        let stepNumber = 0;

        if(routeProgressBar !== false){
            const progressSteps = routes.filter(({ progressBar }) => progressBar !== false);
            const currentRouteIndex = routes.findIndex(({ path }) => location.pathname.endsWith(path));

            stepNumber = currentRouteIndex;
            progressPercent = `${Math.ceil((currentRouteIndex / progressSteps.length) * 100)}%`;
        }

        const progressBarClasses = `${styles.progressBarContainer} ${routeProgressBar === false ? 'hidden' : ''}`;

        return (
            <div className={progressBarClasses} role='progressbar' aria-valuenow={parseInt(progressPercent, 10)} aria-valuemin={0} aria-valuemax={100} aria-label={`Step ${stepNumber} of 9`}>
                <div className={styles.progressBar}>
                    <div className={styles.progressBarGauge} style={{width: progressPercent}}>
                        <div className={styles.progressBarLabel}>
                            <span className={styles.progressBarPercent}>{progressPercent}</span>
                            <span className={styles.progressBarStep}>Step {stepNumber} of 9</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ProgressBar);
